'use strict';
module.exports = function(url) {
  var p, s;
  s = document.createElement('script');
  s.async = true;
  s.src = url;
  p = document.getElementsByTagName('script')[0];
  return p.parentNode.insertBefore(s, p);
};

